export default __webpack_public_path__ + "static/media/dumb.5d883207.png";